import { Avatar, FormInstance, Select } from 'antd'
import { useGetAllTeamsOfDivision } from 'api/Team/Team'
import CustomAvatar from 'components/global/CustomAvatar'
import Spinner from 'components/Spinner'
import React, { useEffect } from 'react'
import { LeagueTeamResp } from 'types/team/leagueTeam'

interface TeamInputProps {
  form: FormInstance
  data: string | undefined
  leagueId: string
  divisionId: string
  fieldId: 'homeTeamId' | 'awayTeamId'
}

const TeamInput: React.FC<TeamInputProps> = ({
  form,
  data,
  leagueId,
  divisionId,
  fieldId,
}) => {
  const {
    isLoading,
    isFetching,
    refetch,
    isError,
    data: teams,
  } = useGetAllTeamsOfDivision(leagueId, divisionId)

  useEffect(() => {
    refetch()
  }, [divisionId])

  return (
    <div>
      <Select
        className="h-50px select-field"
        placeholder={'Select Team'}
        defaultValue={data}
        onChange={(v, item: { value: string; key: string }) => {
          form.setFieldsValue({
            [fieldId]: item.value,
          })
        }}
      >
        {isLoading || isFetching ? (
          <div className="py-40px">
            <Spinner />
          </div>
        ) : isError ? (
          <div className="py-40px flex justify-center align-center">
            <p>Something went wrong while loading teams</p>
          </div>
        ) : (
          teams.map((team: LeagueTeamResp) => (
            <Select.Option key={team._id} value={team._id}>
              <div className="flex align-center gap-10px">
                <CustomAvatar
                  size={20}
                  src={team.team.profilePhoto?.thumb}
                  name={team.team.name}
                />
                <p className="text-14 w-600">{team.team.name}</p>
              </div>
            </Select.Option>
          ))
        )}
      </Select>
    </div>
  )
}

export default TeamInput
